module.exports = __webpack_public_path__ + "nc_static/media/softwareUpgrades.f70757e7.svg";